import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint, PdfBrush, PdfColor } from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { IItemCount } from '@educraft/base';
import { OptsImage } from '../optsImage';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/image';
import '../../pdf/draw/cut';

/**
 * Velikosti (Sizes) - Nested size variations
 *
 * Layout: 5 landscape pages, each with 2 rows of 5 images at decreasing sizes.
 * Each column shows the same image at progressively smaller size within the cell.
 *
 * Migrated from C# EduFrame.Img10.Generators.Velikosti
 */
export class Velikosti implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 50;
  }
  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const width = PdfSize.A4.height / 5;
    const cellWidth = width;
    const cellHeight = (width * 7) / 5;

    const top = (PdfSize.A4.width - 2 * cellHeight) / 2;
    const bgBrush = new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.1));

    const pageCount = Math.ceil(opts.list.length / 2);

    for (let pageIdx = 0; pageIdx < pageCount; pageIdx++) {
      const page = pdf.addPage(true); // landscape

      for (let y = 0; y < 2; y++) {
        const index = pageIdx * 2 + y;
        if (index >= opts.list.length) continue;

        for (let x = 0; x < 5; x++) {
          const rect = new PdfRect(x * cellWidth, top + y * cellHeight, cellWidth, cellHeight);
          const r1 = new PdfRect(
            rect.x + margin,
            rect.y + margin,
            rect.width - margin * 2,
            rect.height - margin * 2
          );
          const inset = margin * (1 + x);
          const r2 = new PdfRect(
            rect.x + inset,
            rect.y + inset,
            rect.width - inset * 2,
            rect.height - inset * 2
          );

          page.drawRectangle(GUtil.cutPen, null, rect);
          page.drawRectangle(null, bgBrush, r1);
          page.drawImageCenter(opts.list[index].image, r2);
        }
      }
    }
  }
}
